import { cloneDeep } from 'lodash';

const convertArrToObj = (arr, keyField) => Object.assign({}, ...arr.map((item) => ({ [item[keyField]]: cloneDeep(item) })));

export default convertArrToObj;
